<template>
  <div class="center_header main-bg1 main-flex main-flex-center">
    <div class="u-centent main-flex main-flex-center" style="justify-content: space-between;">
      <div class="main-font20">
       <router-link to="/"> <a-icon type="home" style="margin-right: 8px;" /><span>{{$t('title.home')}}</span></router-link><span style="padding: 0 30px;">|</span>
       <span class="main-font16" v-if="centername">{{title}}</span>
        <a-dropdown v-else>
          <a style="color: #fff;" @click="e => e.preventDefault()" class="main-font16">
            {{userMember.name}}
            <a-icon type="down" />
          </a>
          <a-menu slot="overlay">
            <a-menu-item key="0">
              <a href="javascript:;" @click="GoUrl('shoppingcar')">{{$t('member.gwc')}}（{{shopcar}}）</a>
            </a-menu-item>
            <a-menu-divider />
            <a-menu-item key="1">
              <a href="javascript:;" @click="GoUrl('payorder')">{{$t('member.cgdd')}}<!-- （{{orderlist}}） --></a>
            </a-menu-item>
            <a-menu-divider />
            <a-menu-item key="3">
              <a href="javascript:;" @click="GoUrl('address')">{{$t('member.shdz')}}</a>
            </a-menu-item>
            <a-menu-divider />
            <a-menu-item key="4">
              <a href="javascript:;" @click="outLogin">{{$t('member.tcdl')}}</a>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </div>
      <div class="u-tab text-right main-font20">
        <span>
          <div class="lang" style="margin-right: 60px;">
            <a-radio-group v-model="langValue" @change="onChange">
              <a-radio value="zh">
                中文
              </a-radio>
              <a-radio value="en">
                English
              </a-radio>
            </a-radio-group>
          </div>
        </span>
        <span style="margin-right: 50px;" :class="{'active':active==='shop'}" @click="GoUrl('shoppingcar')" v-if="right">{{$t('member.gwc')}}</span>
        <span :class="{'active':active==='order'}" @click="GoUrl('payorder')" v-if="right">{{$t('member.cgdd')}}</span>
      </div>
    </div>
  </div>
</template>

<script>
  import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
  import moment from 'moment'
  import 'moment/locale/zh-cn'
  moment.locale('zh-cn')
  const EN = 'en-us'
  const ZH = 'zh-cn'
  export default {
    name: "centerHeader",
    props:{
      centername:{
        type:Boolean,
        default:false
      },
      title:{
        type:String,
        default:''
      },
      right:{
        type:Boolean,
        default:true
      },
      active:{
        type:String,
        default:''
      }
    },
    data() {
      return {
        langValue:this.$store.state.langStates,
        userMember:'',
        shopcar:0,
        orderlist:0
      }
    },
    created() {
      this.init()
    },
    methods:{
      GoUrl(url){
        this.$router.push({path:url})
      },
      onChange(e) {
        if (e.target.value === 'en') {
          moment.locale(EN)
          this.$i18n.locale = EN
          this.langValue = 'en'
          this.locale = null
          this.$store.commit('updateLang','en')
        } else {
          moment.locale(ZH)
          this.$i18n.locale = ZH
          this.langValue = 'zh'
          this.$store.commit('updateLang','zh')
          this.locale = zhCN
        }
      },
      outLogin(){
        localStorage.removeItem('token');
        this.$store.commit('updateToken','')
        setTimeout(() => {
          this.$router.push({
            path:'/'
          })
        }, 500);
      },
      init(){
        this.$api.dongjuapi.member().then(res=>{
          this.userMember = res.data.data
        }).catch(err=>{

        })
        // 购物车列表
        this.$api.dongjuapi.get_carts().then(res => {
          this.shopcar = res.data.data.length
        })
        // 订单列表
        // this.$api.dongjuapi.orders().then(res => {
        //   this.orderlist = res.data.data.length
        // })
      }
    },
  }
</script>

<style lang="less">
  .u-centent {
    width: 1380px;
    margin: 0 auto;
  }
  .center_header {
    width: 100%;
    height: 80px;
    a{
      color: #fff;
    }
    .u-tab{
      span{
        display: inline-block;
        line-height: 80px;
        position: relative;
      }
      .active::before{
        content: '';
        position: absolute;
        width: 0px;
        height: 0px;
        font-size: 0;
        line-height: 0;
        border-width: 10px;
        border-style: solid dashed dashed dashed;
        border-color: transparent transparent #fff transparent;
        background: transparent;
        bottom: -3px;
        left: 0;
        right: 0;
        margin: auto;
      }
    }
  }
</style>
